<template>
  <div class="fatal">
    <span class="version">version {{ version }}</span>

    <div class="illu-fatal" />
    <span class="title"> Oops, there has been a fatal error! </span>
    <pre class="error">{{ message }}</pre>
    <div class="user-infos">
      <span class="routine-id">{{ routineId }}</span>
      •
      <span class="email">{{ email }}</span>
      •
      <span class="timestamp">{{ timestamp }}</span>
    </div>
    <p>
      <strong> The error has been logged for our team to fix the issue.</strong>
    </p>
    <p>
      Please try again by reloading the app. If the error persists, please
      contact us by chat or email at support@routine.co.
    </p>
    <BaseAlert v-if="newVersion" state="default">
      New version available. Click "Install update" below.
    </BaseAlert>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";

import BaseAlert from "@/components/base/BaseAlert.vue";

export default defineComponent({
  components: {
    BaseAlert,
  },
  props: {
    newVersion: {
      type: String as PropType<string>,
      required: false,
    },
    version: { type: String, required: true },
    message: { type: String as PropType<string | null>, required: true },
    email: { type: String, required: true },
    routineId: { type: String, required: true },
    timestamp: { type: String, required: true },
  },
});
</script>
<style scoped lang="scss">
.illu-fatal {
  background-size: 245px 152px;
  width: 245px;
  height: 152px;
  margin: 0 auto;
  @include themed() {
    background-image: t($illu-not-owned-event);
  }
}

.fatal {
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  user-select: text;
  max-width: 550px;
  @include themed() {
    color: t($primary);
  }

  .error {
    font-family: monospace;
    line-height: 150%;
    white-space: pre-wrap;
    font-size: 12px;
    padding: 12px;
    margin: 0;
    border-radius: $border-radius-l;
    @include themed() {
      color: t($grey-70);
      background-color: t($grey-05);
    }
  }

  .user-infos {
    display: flex;
    column-gap: 4px;
  }

  .user-infos,
  .version {
    @extend %font-small-regular;
    @include themed() {
      color: t($grey-50);
    }
  }

  .version {
    position: absolute;
    top: 12px;
    inset-inline-end: 16px;
  }

  .title {
    @extend %font-h3;
  }

  .new-version {
    width: 100%;
    padding: 12px 0;
    @include themed() {
      color: t($tertiary-50);
      background-color: t($tertiary-10);
    }
  }
}
</style>
